<template>
<div :class="profile.persons.length === 2 || extendedPerson ? 'col-md-4 col-mobile' : 'col-md-6 col-mobile'">
    <section class="card">
        <h1 v-if="!extendedPerson">
            <editable :params="personParams[index]" property="name"
                :value="person.name ? person.name : `Person${index + 1}`" :editable="editMode"></editable>
        </h1>
        <table class="table">
            <tbody>
                <tr v-if="editMode && profile.persons.length > 1">
                    <th>{{ t.stats.gender }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="genderOptions" property="gender" type="select"
                            :value="person.gender ? person.gender : 0"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.sexuality }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="sexualityOptions" property="sexuality" type="select"
                            :value="person.sexuality" :editable="editMode"></editable>
                        <span v-if="!editMode">{{ genderOptions.filter(option => option.value === person.gender)[0].text }}</span>
                    </td>
                </tr>
                <tr v-if="!editMode">
                    <th>{{ t.stats.age }}</th>
                    <td>{{ person.age }}</td>
                </tr>
                <tr v-else>
                    <th>{{ t.stats.dob }}</th>
                    <td><editable :params="personParams[index]" property="dob" type="dob" :value="person.dob"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.assets }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="assetOptions" property="asset" type="select"
                            :value="person.asset" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.build }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="buildOptions" property="build" type="select"
                            :value="person.build" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.drink }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="drinkOptions" property="drink" type="select"
                            :value="person.drink" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.height }}</th>
                    <td>
                        <editable :params="personParams[index]" property="height" :type="`height${localConfig.data.heightUnit}`"
                            :value="person.height ? person.height : 0" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.smoke }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="smokeOptions" property="smoke" type="select"
                            :value="person.smoke" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.trans }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="transOptions" property="extra" type="select"
                            :value="person.trans || ''" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr v-if="localConfig.data.showEthnicity">
                    <th>{{ t.stats.ethnicity }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="ethnicityOptions" property="ethnicity" type="select"
                            :value="person.ethnicity" :editable="editMode"></editable>
                    </td>
                </tr>
            <template v-if="extendedPerson">
                <tr>
                    <th>{{ t.stats.extended.attitude }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="attitudeOptions" property="attitude" type="select"
                            :value="person.attitude" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.behaviour }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="behaviourOptions" property="behaviour" type="select"
                            :value="person.behaviour" :editable="editMode"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.character_type }}</th>
                    <td>
                        <editable :params="personParams[index]" :options="characterTypeOptions" property="characterType" type="select"
                            :value="person.characterType" :editable="editMode"></editable>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
    </section>
</div>
</template>

<script>
import Editable from 'Site/component/Editable.vue';
import { mapState } from 'vuex';

export default {
    name: 'ProfileStats',
    components: {
        Editable
    },
    computed: {
        ...mapState({
            config: state => state.config.data
        }),
        extendedPerson() { return this.localConfig.data.extendedPerson; },
        assetOptions() { return this.localConfig.data.formOptions.asset; },
        buildOptions() { return this.localConfig.data.formOptions.build; },
        drinkOptions() { return this.localConfig.data.formOptions.drink; },
        ethnicityOptions() { return this.localConfig.data.formOptions.ethnicity; },
        personParams() {
            return [
                { url: 'person', id: this.profile.persons[0].id },
                { url: 'person', id: this.profile.persons[1] ? this.profile.persons[1].id : null }
            ];
        },
        sexualityOptions() { return this.localConfig.data.formOptions.sexuality; },
        smokeOptions() { return this.localConfig.data.formOptions.smoke; },
        transOptions() { return this.localConfig.data.formOptions.extra; }
    },
    data() {
        const { config } = this.$store.state;
        const data = {
            genderOptions: [
                { value: 0, text: this.t.user_view.female },
                { value: 1, text: this.t.user_view.male }
            ]
        };
        if (config.data.extendedPerson) {
            data.attitudeOptions = this.localConfig.data.formOptions.attitude;
            data.behaviourOptions = this.localConfig.data.formOptions.behaviour;
            data.characterTypeOptions = this.localConfig.data.formOptions.characterType;
        }
        return data;
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        localConfig: {
            type: Object,
            required: true
        },
        index: {
            type: Number
        },
        person: {
            type: Object,
            required: true
        },
        profile: {
            type: Object,
            required: true
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>
